/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Draft_BadgeInputs */

const cs_property_ai_draft_badge = /** @type {(inputs: Property_Ai_Draft_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Návrh`)
};

const en_property_ai_draft_badge = /** @type {(inputs: Property_Ai_Draft_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft`)
};

/**
* | output |
* | --- |
* | "Draft" |
*
* @param {Property_Ai_Draft_BadgeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_draft_badge = /** @type {((inputs?: Property_Ai_Draft_BadgeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Draft_BadgeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_draft_badge(inputs)
	return cs_property_ai_draft_badge(inputs)
});